import React from 'react';

import Dialog, {DialogProps} from '@material-ui/core/Dialog';

import styles from './CustomDialog.module.css';


const CustomDialog = (props: DialogProps) => {
  return (
    <Dialog
      classes={{
        root: styles.root,
        paper: styles.paper,
      }}
      {...props}
      maxWidth="md"
    >
      {props.children}
    </Dialog>
  );
};

export default CustomDialog;